const normalizePathname = (pathOrPathname: string) => {
  const trimmed = String(pathOrPathname || '').trim()
  if (!trimmed) {
    return '/'
  }

  const [withoutHash] = trimmed.split('#')
  const [withoutQuery] = withoutHash.split('?')
  if (!withoutQuery) {
    return '/'
  }

  return withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`
}

export function resolveEventFamilyAssignmentsBasePath(pathOrPathname: string): string {
  const pathname = normalizePathname(pathOrPathname)

  if (pathname.startsWith('/committees/')) {
    return '/committees/assignments'
  }

  if (pathname.startsWith('/committee/')) {
    return '/committee/assignments'
  }

  if (pathname.startsWith('/tasks/')) {
    return '/tasks/assignments'
  }

  if (pathname.startsWith('/task/')) {
    return '/task/assignments'
  }

  return '/events/assignments'
}

export function resolveEventFamilyAssignmentsCreatePath(pathOrPathname: string): string {
  return `${resolveEventFamilyAssignmentsBasePath(pathOrPathname)}/create`
}
